import {DataSourceConfig} from './data-source-config.model';
import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {DataSourceFriendlyName, DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class OneRosterConfig extends DataSourceConfig {
    vendorKey: string;
    vendorSecret: string;

    constructor(
        public oneRosterBaseUrl: string = '',
        public clientId: string = '',
        public clientSecret: string = '',
        public authUrl: string = '',
        friendlyName: string = ''
    ) {
        super(<DefaultSchemaName>'', friendlyName);
        this.dataSourceType = DataSourceType.OneRoster;
    }
}

export const ONEROSTER_V11_SUFFIX = '/ims/oneroster/v1p1';
export const ONEROSTER_V12_SUFFIX = '/ims/oneroster/rostering/v1p2';
export const LUMENTOUCH_V12_PREFIX = '/state-reporting-mo.lumentouchhosts.com';
export const SAPPHIRE_SUFFIX = '/ims/oauth2/token';
export const OneRosterDataSourceFriendlyNamesWithEnteredByUserAuthUrl: string[] = [
    DataSourceFriendlyName['Infinite Campus'],
    DataSourceFriendlyName['Skyward (OneRoster)'],
    DataSourceFriendlyName['SchoolTool'],
    DataSourceFriendlyName['Aspire']
];
